import { useState, useRef, useEffect } from "react";
import { Globe, ChevronDown } from "lucide-react";
import { useT, SUPPORTED_LANGS } from "../i18n/LanguageContext";

export const LanguageSwitcher = ({ variant = "navbar" }) => {
  const { lang, setLang } = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const current = SUPPORTED_LANGS.find((l) => l.code === lang) || SUPPORTED_LANGS[0];

  return (
    <div ref={ref} className="relative" data-testid={`lang-switcher-${variant}`}>
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid={`lang-switcher-toggle-${variant}`}
        className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.18em] text-[var(--espresso-soft)] hover:text-[var(--gold-deep)] transition-colors px-2 py-2 border border-transparent hover:border-[var(--sand)]"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <Globe className="w-3.5 h-3.5" />
        <span>{current.label}</span>
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul
          role="listbox"
          className="absolute right-0 mt-2 min-w-[180px] bg-[var(--ivory)] border border-[var(--sand)] shadow-[0_18px_40px_-12px_rgba(42,31,24,0.18)] z-50"
        >
          {SUPPORTED_LANGS.map((l) => (
            <li key={l.code}>
              <button
                onClick={() => { setLang(l.code); setOpen(false); }}
                data-testid={`lang-option-${l.code}`}
                className={`w-full flex items-center gap-3 px-4 py-2.5 text-left text-sm transition-colors ${
                  l.code === lang
                    ? "bg-[var(--cream)] text-[var(--gold-deep)] font-semibold"
                    : "text-[var(--espresso)] hover:bg-[var(--cream)]"
                }`}
              >
                <span className="text-base leading-none">{l.flag}</span>
                <span className="flex-1">{l.name}</span>
                <span className="text-[10px] uppercase tracking-widest text-[var(--warm-gray)]">{l.label}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
